var LoadVideo = function (player_id) {
  var Program = {
    Init: function () {
      this.NewPlayer();
      this.EventHandler();
    },

    NewPlayer: function () {
      this.Player = new YT.Player(player_id,
        {
          events: {
            'onReady': onPlayerReady
          }
        });
      this.Player.$elementVideo = $('#' + player_id);
      this.Player.$elementTN = $('#' + player_id + '-thumbnail');
    },

    Play: function () {
      if (typeof this.Player.getPlayerState === "function") {
        if (this.Player.getPlayerState() === 1) return;
        this.Player.playVideo();
      }
    },

    Pause: function () {
      if (typeof this.Player.getPlayerState === "function") {
        if (this.Player.getPlayerState() === 2) return;
        this.Player.pauseVideo();
      }
    },

    ScrollControl: function () {
      if (
        (this.Player.$elementTN.css('display') == 'block') && Utils.IsElementInViewport(this.Player.$elementTN) ||
        (this.Player.$elementVideo.css('display') == 'block' && Utils.IsElementInViewport(this.Player.$elementVideo))
      ) {
        document.getElementById(this.Player.$elementVideo[0].id + '-thumbnail').style.display = "none";
        document.getElementById(this.Player.$elementVideo[0].id).style.display = "block";
        this.Play();
      } else {
        this.Pause();
      }
    },


    EventHandler: function () {
      var _this = this;
      $(window).on('scroll', function () {
        _this.ScrollControl();
      }).trigger('scroll');
    }
  };

  var Utils = {
    IsElementInViewport: function (el) {
      if (typeof jQuery === "function" && el instanceof jQuery) el = el[0];
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

  };

  function onPlayerReady(event) {
    if (
      (event.target.$elementTN.css('display') == 'block') && Utils.IsElementInViewport(event.target.$elementTN) ||
      (event.target.$elementVideo.css('display') == 'block' && Utils.IsElementInViewport(event.target.$elementVideo))
    ) {
      document.getElementById(event.target.$elementVideo[0].id + '-thumbnail').style.display = "none";
      document.getElementById(event.target.$elementVideo[0].id).style.display = "block";
      event.target.playVideo();
    }
  }

  return Program.Init();
};

if (typeof (YT) === 'undefined' || typeof (YT.Player) === 'undefined') {
  window.onYouTubePlayerAPIReady = () => {
    $('.videoplayer').each(function (i, obj) {
      LoadVideo($(this).attr('id'));
    });
  }
} else {
  $('.videoplayer').each(function (i, obj) {
    LoadVideo($(this).attr('id'));
  });
}
